import { GreenGlass10 } from './green-glass-10.tsx'
import { HighlightGreen10 } from './highlight-green-10.tsx'
import type { SvgGradientName, SvgGradientProps } from './types.ts'

export const svgGradientMap: Record<SvgGradientName, SvgGradientProps> = {
  'green-glass-10': {
    id: 'svg-gradient-green-glass-10',
    component: GreenGlass10,
  },
  'highlight-green-10': {
    id: 'svg-gradient-highlight-green-10',
    component: HighlightGreen10,
  },
}

export const getSvgGradient = (name: SvgGradientName) => {
  return svgGradientMap[name]
}
